import { instance } from '@/services/avik-api-gateway'
export interface AvikGraphTimetableItem {
  core: string
  departureDate: string
  direction: string
  eventMessageDatetime: string
  eventType: string
  operator: string
  owner: string
  placeEnd: string
  placeStart: string
  trainid: string
  typeOfTrain: string
  places: {
    actualArrivalTime: null
    actualDepartureTime: null
    distance: number
    location: string
    direction: string
    plannedArrivalTime: string | null
    plannedDepartureTime: string | null
    track: string | null
  }[]
}

export function getAvikGraphTimetable(params: {
  departureDate: string
  core: string
}): Promise<AvikGraphTimetableItem[]> {
  return instance
    .get<AvikGraphTimetableItem[]>(`/graph/timetables`, {
      params: { coreParsed: params.core, departureDate: params.departureDate },
    })
    .then((res) => {
      return res.data.map((x) => ({
        ...x,
        places: x.places.map((p) => ({
          ...p,
          direction: x.direction,
          location: p.location.toLowerCase(),
        })),
      }))
    })
}
